import { makeStyles } from '@material-ui/styles'

const styles = makeStyles(theme => ({
  root: {
    zIndex: '9999 !important'
  },
}))

export default styles
